/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} BackInputs */

const en_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Back`)
};

const ar_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عودة`)
};

const de_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zurück`)
};

const es_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volver`)
};

const fr_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Retour`)
};

const it_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indietro`)
};

const ja_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`戻る`)
};

const ko_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`뒤로`)
};

const pt_br_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voltar`)
};

const ru_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Назад`)
};

const th_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กลับไป`)
};

const tr_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geri`)
};

const zh_cn_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回`)
};

const zh_tw_back = /** @type {(inputs: BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`返回`)
};

/**
* | output |
* | --- |
* | "Back" |
*
* @param {BackInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const back = /** @type {((inputs?: BackInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<BackInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_back(inputs)
	if (locale === "ar") return ar_back(inputs)
	if (locale === "de") return de_back(inputs)
	if (locale === "es") return es_back(inputs)
	if (locale === "fr") return fr_back(inputs)
	if (locale === "it") return it_back(inputs)
	if (locale === "ja") return ja_back(inputs)
	if (locale === "ko") return ko_back(inputs)
	if (locale === "pt_br") return pt_br_back(inputs)
	if (locale === "ru") return ru_back(inputs)
	if (locale === "th") return th_back(inputs)
	if (locale === "tr") return tr_back(inputs)
	if (locale === "zh_cn") return zh_cn_back(inputs)
	return zh_tw_back(inputs)
});